import React from "react";
import { TextFieldProps } from "@mui/material";
import color from "../../../Constants/colors";
import { useWorkspaceColors } from "../../../Contexts/WorkspaceColorContext";
import { ComoInput } from "../../Common/ComoInput";

const VoicesInput: React.FC<TextFieldProps> = ({ sx, SelectProps, ...props }) => {
  const { colors: workspace } = useWorkspaceColors();

  return (
    <ComoInput
      primaryColor={workspace.accent}
      SelectProps={{
        displayEmpty: true,
        ...SelectProps,
        MenuProps: {
          ...SelectProps?.MenuProps,
          PaperProps: {
            sx: {
              backgroundColor: color.white,
              border: `1px solid ${color.gray200}`,
              borderLeft: `4px solid ${workspace.accent}`,
              "& .MuiMenuItem-root": {
                color: color.gray900,
                "&:hover": { backgroundColor: color.orange50 },
                "&.Mui-selected, &.Mui-selected:hover": {
                  backgroundColor: color.orange50,
                  color: workspace.accent,
                  fontWeight: 600,
                },
                "&.Mui-disabled": { color: color.gray400, opacity: 1 },
              },
            },
          },
        },
      }}
      sx={{
        "& .MuiOutlinedInput-root": { color: color.gray900 },
        "& .MuiInputBase-input, & .MuiOutlinedInput-inputMultiline, & textarea, & .MuiSelect-select":
          { color: color.gray900 },
        "& .MuiSelect-icon, & .MuiAutocomplete-popupIndicator, & .MuiAutocomplete-clearIndicator":
          { color: color.gray500 },
        "& .MuiOutlinedInput-root.Mui-disabled": {
          backgroundColor: color.gray50,
          color: `${color.gray700} !important`,
        },
        "& .MuiInputBase-input.Mui-disabled, & .MuiSelect-select.Mui-disabled": {
          color: `${color.gray700} !important`,
          WebkitTextFillColor: `${color.gray700} !important`,
        },
        "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
          borderColor: color.gray200,
        },
        "& .MuiFormHelperText-root": { color: color.gray500 },
        "& .MuiFormHelperText-root.Mui-error": { color: color.red600 },
        ...sx,
      }}
      {...props}
    />
  );
};

export default VoicesInput;
